module.exports = __webpack_public_path__ + "img/HL.830f2733.svg";